import React from "react";
import {
  TextField,
  Box,
  Paper,
  Typography,
  FormControl,
  FormLabel,
  Button,
  Tooltip,
  IconButton,
  Breadcrumbs,
  MenuItem,
  Alert,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  InputLabel,
  Select,
  Stack,
  Checkbox,
  Dialog,
  Radio,
  RadioGroup,
  DialogActions,
  FormControlLabel,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { Formik } from "formik";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useDispatch, useSelector } from "react-redux";
import {
  fetchApidata,
  getFetchData,
  getFetchsalaryData,
  postApidata,
  postData,
  RepaymentHDget,
  RepaymentSchedule,
  RepaymentSchedulePost,
  requestMail,
  resetTrackingData,
} from "../../../store/reducers/Formapireducer";
import FileListPopup from "../../../ui-components/FIleViewDialog";
import FileUploadIconButton from "../../../ui-components/FileUploadButton";
import { attachmentPost } from "../../../store/reducers/LoginReducer";
import GradingIcon from '@mui/icons-material/Grading';
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useEffect, useState, useRef } from "react";
import Popup from "../popup";
import Listviewpopup from "../Lookup";
import Swal from "sweetalert2";
import { LoadingButton } from "@mui/lab";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { FinanceSchema } from "../../Security/validation";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import axios from "axios";
import store from "../../../index";
import {
  fileUpload,
  imageUpload,
} from "../../../store/reducers/Imguploadreducer";
import {
  DataGrid,
  GridRowModes,
} from "@mui/x-data-grid";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { financeentrySchema } from "../../Security/validation";
import { fetchExplorelitview } from "../../../store/reducers/Explorelitviewapireducer";
import { CheckinAutocomplete, Productautocomplete } from "../../../ui-components/global/Autocomplete";
import { leaveAppoval, mailNotify } from "../../../store/reducers/Listviewapireducer";
import * as Yup from "yup";
import CryptoJS from 'crypto-js';
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../../ui-components/global/utils";
import { tokens } from "../../../Theme";
import { useTheme } from "@emotion/react";
import { nanoid } from "@reduxjs/toolkit";
import {
  GridToolbarContainer,
  GridToolbarQuickFilter,
  GridActionsCellItem
} from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import { setRepaymentRows } from "../../../store/reducers/Formapireducer";
// import ErrorMsgData from "../../Security/validationMsg.json"

// const validationSchema = Yup.object().shape({
//   purpose: Yup.object().required(ErrorMsgData.Salaryadvance.purpose).nullable(),
//   date: Yup.string().required(ErrorMsgData.Salaryadvance.date),
//   amount: Yup.string().required(ErrorMsgData.Salaryadvance.amount),
//   comments: Yup.string().required(ErrorMsgData.Salaryadvance.comments),
//   referenceifany: Yup.string().required(ErrorMsgData.Salaryadvance.referenceifany),
// });
const KEY = CryptoJS.enc.Utf8.parse('1234567890123456'); // 16-byte key
const IV = CryptoJS.enc.Utf8.parse('1234567890123456');  // 16-byte IV


export function encryptDataUrlSafe(plainText) {
  const encrypted = CryptoJS.AES.encrypt(plainText, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(); // Standard base64

  // Convert to URL-safe base64
  return encrypted.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function decryptData(encryptedBase64) {
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: CryptoJS.enc.Base64.parse(encryptedBase64) },
    KEY,
    {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );

  return decrypted.toString(CryptoJS.enc.Utf8); // Original string
}
const Editsalaryadvance = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const accessID = params.accessID;
  const recID = params.id;
  const EMPID = sessionStorage.getItem("EmpId");
  const mode = params.Mode;
  console.log(mode, "--Mode");
  const rowSx = { height: 36, '& td, & th': { py: 0.5 } };
  console.log(params, "find Screen Params");
  var parentID = params.parentID;
  console.log(parentID, "--parentID");
  const filtertype = params.filtertype;
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const rowData = location.state || {};
  console.log(rowData, "--find rowData");
  const navigate = useNavigate();
  const data = useSelector((state) => state.formApi.Data);
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const Repaymentget = useSelector((state) => state.formApi.repaymentget);
  console.log(Repaymentget, "--Repaymentget");
  const [loading, setLoading] = useState(false);
  const [imgloading, setimgLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [show, setScreen] = React.useState("0");
  const [error, setError] = useState('');
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const Finyear = sessionStorage.getItem("YearRecorid");
  const CompanyID = sessionStorage.getItem("companyId");
  const [showImage, setShowImage] = useState(mode == "IM" ? true : false);
  console.log(CompanyID, "--CompanyID");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(0);


  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  console.log(SubscriptionCode, is003Subscription, "SubscriptionCode");


  const repaymentgetLoading = useSelector((state) => state.formApi.repaymentgetLoading);
  const RepaymentHDgetDataLoading = useSelector((state) => state.formApi.RepaymentHDgetDataLoading);
  const Header = useSelector((state) => state.formApi.RepaymentHDgetHeader);
  const Detail = useSelector((state) => state.formApi.RepaymentHDgetData);
  console.log(Header, "--Header");
  console.log(Detail, "--Detail");
  const [rows, setRows] = React.useState([]);
  const [isGenerated, setIsGenerated] = useState(false);
  const gridRows = isGenerated ? Repaymentget : rows;

  useEffect(() => {
    if (Detail && Detail.length > 0) {
      const formattedRows = Detail.map((row) => ({
        ...row,
        Hold: row.Accountant === "Y" ? "Y" : "N",
      }));

      setRows(formattedRows);
    } else {
      setRows([]);
    }
  }, [Detail]);
  const screenChange = (event) => {
    setScreen(event.target.value);
    if (event.target.value == "1") {
      dispatch(
        RepaymentHDget({
          data: [
            {
              SalaryAdvanceID: recID,
              EmployeeID: EMPID,
            },
          ],
        })
      );
    }
  }
  // useEffect(() => {
  //   dispatch(resetTrackingData());
  // }, [dispatch]);
  // companyId
  // const { toggleSidebar, broken, rtl } = useProSidebar();
  // const validationSchema = Yup.object().shape({
  //   purpose: Yup.object()
  //     .nullable()
  //     .required("Purpose is required"),
  // });
  const [selectedRows, setSelectedRows] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [currentRowId, setCurrentRowId] = useState(null);
  useEffect(() => {
    dispatch(getFetchData({ accessID, get: "get", recID })).then((res) => {
      console.log(res, "response");
      var url = store.getState().globalurl.empGetAttachmentUrl;
      axios
        .get(url, {
          params: {
            empId: data.EmployeeID,
            appId: recID
          }
        })
        .then((response) => {
          setFiles(response.data);
        })
        .catch((err) => {
          setError('Failed to fetch attachments.');
          console.error(err);
        })
        .finally(() => setLoading(false));
    })
  }, []);
  const [errorMsgData, setErrorMsgData] = useState(null);
  const [validationSchema, setValidationSchema] = useState(null);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
        const schema = Yup.object().shape({
          purpose: Yup.object().required(data.Salaryadvance.purpose).nullable(),
          date: Yup.string().trim().required(data.Salaryadvance.date),
          amount: Yup.string().trim().required(data.Salaryadvance.amount),
          comments: Yup.string().trim().required(data.Salaryadvance.comments),
          referenceifany: Yup.string().trim().required(data.Salaryadvance.referenceifany),
          // managerComments: Yup.string().required(data.Salaryadvance.managerComments),
          managerComments:
            mode === "M" ||
              (mode === "E" && (data.Status === "RJ" || data.Status === "QR"))
              ? Yup.string().required(
                data?.Salaryadvance?.managerComments || "Manager Comments is required"
              )
              : Yup.string().notRequired(),
          Status: mode === "M" ? Yup.string().required(data.Salaryadvance.Status) : Yup.string().notRequired(),



        });

        setValidationSchema(schema);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, [mode, data.Status]);
  const [ImageName, setImgName] = useState("");

  const isNonMobile = useMediaQuery("(min-width:600px)");

  const currentDate = new Date().toISOString().split("T")[0];
  const initialValue = {
    applieddate: mode == "A" ? currentDate : data.AppliedDate,
    OHRecordID: data.OverHeadsID,
    date: data.SalaryAdvanceDate,
    referenceifany: data.ReferranceIfAny,
    amount: data.Amount || "0.00",
    comments: data.Comments,
    purpose: data.OverHeadsID
      ? { RecordID: data.OverHeadsID, Name: data.Name }
      : null,
    managerComments: mode == "M" ? data.ManagerComments : "",
    Status: data.Status || "",

  };

  const salAdFNsave = async (values, resetForm, del) => {
    setLoading(true);
    // console.log(funMode, "+  funMode");

    let action =
      mode === "A" && !del
        ? "insert"
        : mode === "E" && del
          ? "harddelete"
          : "update";

    const idata = {
      RecordID: recID,
      SalaryAdvanceDate: values.date,
      ReferranceIfAny: values.referenceifany,
      OverHeadsID: values?.purpose?.RecordID || 0,
      Name: values?.purpose?.Name || "",
      Amount: values.amount,
      Comments: values.comments,
      EmployeeID: mode == "M" ? params.parentID : EMPID,
      Status:
        mode == "A"
          ? "AL"
          : mode == "E" && values.Status == "QR"
            ? "AL"
            : values.Status,
      AppliedDate: values.applieddate,
      Reason: values.comments,
      ManagerComments: values.managerComments,
      Source: "Self",
    };
    const response = await dispatch(
      postData({ accessID: "TR160", action, idata })
    );
    if (response.payload.Status == "Y") {
      setLoading(false);
      if (mode == "A") {
        dispatch(
          requestMail({
            EmployeeID: EMPID,
            Type: "SA",
            RecordID: response.payload.SalaryAdvanceRecid,
            encryptData: encryptDataUrlSafe(response.payload.SalaryAdvanceRecid)
          })
        );
        dispatch(
          leaveAppoval({
            data: {
              RecordID: response.payload.SalaryAdvanceRecid,
              ManagerID: "",
              EmployeeID: EMPID,
              Type: "SA",
              Status: "AL",
              Reason: values.comments,
            },
          })
        );
      }
      if (mode == "M") {
        dispatch(
          leaveAppoval({
            data: {
              RecordID: recID,
              ManagerID: EMPID,
              EmployeeID: params.parentID,
              Type: "SA",
              Status:
                values.Status == "AP"
                  ? "Y"
                  : values.Status == "QR"
                    ? values.Status
                    : "N",
              Reason: values.comments,
              Source: "M",
            },
          })
        );
        dispatch(mailNotify({
          RecordID: recID,
          ManagerID: EMPID,
          EmployeeID: params.parentID,
          Type: "SA",
          Status:
            values.Status == "AP"
              ? "Y"
              : values.Status == "QR"
                ? values.Status
                : "N",
          Reason: values.comments,
          Source: "M",

        }));
      }

      toast.success(response.payload.Msg);
      navigate(-1);
      resetForm();
    } else {
      setLoading(false);
      toast.error(response.payload.Msg);
    }
  };
  const getMonthValue = (monthName, year) => {
    if (!monthName) return "";

    const months = {
      January: "01",
      February: "02",
      March: "03",
      April: "04",
      May: "05",
      June: "06",
      July: "07",
      August: "08",
      September: "09",
      October: "10",
      November: "11",
      December: "12",
    };

    return `${year}-${months[monthName]}`;
  };
  const year = Header?.DueDate?.split("-")[0];

  const RepayinitialValue = {
    applieddate: data.AppliedDate,
    amount: data.Amount || "0.00",
    Type: Header?.Type ?? "P",
    fromdate: getMonthValue(Header?.FromPeriod, year) || "",
    todate: getMonthValue(Header?.ToPeriod, year) || "",
    duedate: Header?.DueDate ?? "",
    dueamount: Header?.DueAmount ?? "0.00",
    // dueamount: Header?.HeaderDueAmt ?? "0.00",
    comments: Header?.Comments ?? "",
  };
  const handleApplyClick = async (values) => {

    const getMonthName = (dateValue) => {
      if (!dateValue) return "";
      const date = new Date(dateValue);
      return date.toLocaleString("default", { month: "long" });
    };

    const fromPeriod = getMonthName(values.fromdate);
    const toPeriod = getMonthName(values.todate);
    if(!fromPeriod && values.Type === "P"){
      toast.error("Please select From Period");
      return;
    }
    if(!toPeriod && values.Type === "P"){
      toast.error("Please select To Period");
      return;
    }
    setIsGenerated(true);
    const idata = {
      SalaryAdvanceID: recID,
      EmployeeID: EMPID,
      Type: values.Type || "",
      DueDate: values.duedate || "",
      FromPeriod: values.Type === "P" ? getMonthName(values.fromdate) : "",
      ToPeriod: values.Type === "P" ? getMonthName(values.todate) : "",
      DueAmount: values.dueamount || 0.00,
      Comments: values.comments || "",
      Accountant: "N"
    };
    try {
      const response = await dispatch(RepaymentSchedule(idata));

      if (response.payload.Status === "Y") {
        toast.success("Data Fetched Successfully");

      } else {
        toast.error("Failed to generate repayment schedule.");
      }
    } catch (error) {
      toast.error("Error occurred during save.");
    }

  };
  // const handleDialogSave = () => {
  //   if (!selectedOption) {
  //     // nothing selected → keep Hold = N
  //     setOpenDialog(false);
  //     return;
  //   }

  //   const updatedRows = Repaymentget.map((row) => {
  //     if (row.SlNo === currentRowId) {
  //       return {
  //         ...row,
  //         Accountant: "Y",

  //       };
  //     }
  //     return row;
  //   });

  //   setRepaymentRows(updatedRows);

  //   if (selectedOption === "equal") {
  //     applyEqualApportion();
  //   }

  //   if (selectedOption === "lastMonth") {
  //     applyAddLastMonth();
  //   }

  //   setOpenDialog(false);
  //   setSelectedOption("");
  // };
  const handleDialogSave = () => {
    if (!selectedOption) {
      setOpenDialog(false);
      return;
    }

    const gridRows = isGenerated ? Repaymentget : rows;

    const updatedRows = gridRows.map((row) => {
      if (row.SlNo === currentRowId) {
        return {
          ...row,
          Accountant: "Y",
          Option: selectedOption
        };
      }
      return row;
    });

    if (isGenerated) {
      dispatch(setRepaymentRows(updatedRows));
    } else {
      setRows(updatedRows);
    }

    if (selectedOption === "equal") {
      applyEqualApportion();
    }

    if (selectedOption === "lastMonth") {
      applyAddLastMonth();
    }

    setOpenDialog(false);
  };

  const applyEqualApportion = () => {
    const gridRows = isGenerated ? Repaymentget : rows;
    const updated = gridRows.map((row) => ({ ...row }));

    const holdIndex = updated.findIndex((r) => r.SlNo === currentRowId);
    if (holdIndex === -1) return;

    const holdAmount = parseFloat(updated[holdIndex].DueAmount) || 0;

    // mark selected row
    updated[holdIndex] = {
      ...updated[holdIndex],
      DueAmount: 0,
      Accountant: "Y",
      Option: "equal",
    };

    const eligibleRows = updated.filter(
      (row) =>
        row.SlNo !== currentRowId &&
        (!row.Option || row.Option === "") &&
        row.Accountant !== "Y"
    );

    if (eligibleRows.length === 0) {
      console.warn("No rows available for splitting");
      return;
    }

    const splitAmount = holdAmount / eligibleRows.length;

    const finalRows = updated.map((row) => {
      if (
        row.SlNo !== currentRowId &&
        (!row.Option || row.Option === "") &&
        row.Accountant !== "Y"
      ) {
        return {
          ...row,
          DueAmount: (Number(row.DueAmount) + splitAmount).toFixed(2),
        };
      }
      return row;
    });

    if (isGenerated) {
      dispatch(setRepaymentRows(finalRows));
    } else {
      setRows(finalRows);
    }
  };
  const applyAddLastMonth = () => {
    const gridRows = isGenerated ? Repaymentget : rows;
    const updated = gridRows.map((row) => ({ ...row }));

    const holdIndex = updated.findIndex((r) => r.SlNo === currentRowId);
    if (holdIndex === -1) return;

    const holdAmount = Number(updated[holdIndex].DueAmount).toFixed(2);

    updated[holdIndex] = {
      ...updated[holdIndex],
      DueAmount: 0,
      Accountant: "Y",
    };

    const lastRow = updated[updated.length - 1];

    const [day, month, year] = lastRow.DueDate.split("-");
    const date = new Date(year, month - 1, day);

    date.setMonth(date.getMonth() + 1);

    const nextMonthName = date.toLocaleString("default", { month: "long" });

    const newMonth = String(date.getMonth() + 1).padStart(2, "0");
    const newYear = date.getFullYear();

    const dueDate = `10-${newMonth}-${newYear}`;

    const newRow = {
      ...lastRow,
      SlNo: updated.length + 1,
      FromPeriod: nextMonthName,
      DueDate: dueDate,
      DueAmount: holdAmount,
      Accountant: "N",
    };

    updated.push(newRow);

    if (isGenerated) {
      dispatch(setRepaymentRows(updated));
    } else {
      setRows(updated);
    }
  };
  const column = [
    {
      field: "SlNo",
      headerName: "SL#",
      width: 60,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      disableColumnMenu: true,
      valueGetter: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

        const totalVisibleRows = params.api.getAllRowIds().length;
        const totalAllRows = params.api.getRowsCount();

        if (totalVisibleRows < totalAllRows) {
          return index + 1;
        } else {
          return page * pageSize + index + 1;
        }
      },
    },
    {
      field: "FromPeriod",
      headerName: "Month",
      width: 120,
      headerAlign: "center",
      align: "left",
    },

    {
      field: "DueDate",
      headerName: "Due Date",
      width: 120,
      headerAlign: "center",
      align: "center",

    },
    {
      field: "DueAmount",
      headerName: "Due Amount",
      width: 120,
      headerAlign: "center",
      align: "right",
      Editable: true,
      valueFormatter: ({ value }) => {
        const num = Number(value);
        return isNaN(num) ? "0.00" : num.toFixed(2);
      }
    },
    {
      field: "Accountant",
      headerName: "Hold",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Checkbox
          checked={params.row.Accountant === "Y"}
          onChange={() => {

            const gridRows = isGenerated ? Repaymentget : rows;

            const selectedRow = gridRows.find(
              (r) => r.SlNo === params.row.SlNo
            );

            setSelectedOption(selectedRow?.Option || "");
            setCurrentRowId(params.row.SlNo);
            setOpenDialog(true);
          }}
        />
      )
    }
    // {
    //   field: "actions",
    //   headerName: "Hold",
    //   headerAlign: "center",
    //   align: "center",
    //   width: 100,
    //   sortable: false,
    //   filterable: false,
    //   renderCell: (params) => {
    //     return (
    //       <Checkbox
    //         checked={params.row.Accountant === "Y"}
    //         onChange={(e) => {
    //           const checked = e.target.checked;

    //           const updatedRows = rows.map((row) =>
    //             row.SlNo === params.id
    //               ? { ...row, Accountant: checked ? "Y" : "N" }
    //               : row
    //           );

    //           setRows(updatedRows);

    //           if (checked) {
    //             setCurrentRowId(params.id);
    //             setOpenDialog(true);
    //           }
    //         }}
    //       />
    //     );
    //   },
    // }

  ];
  // const handleSaveButtonClick = async () => {
  //   const dataArray = Repaymentget.map((row) => ({
  //     SalaryAdvanceID: row.SalaryAdvanceID || 0,
  //     EmployeeID: row.EmployeeID || 0,
  //     Type: row.Type || "",
  //     DueDate: row.DueDate || "",
  //     FromPeriod: row.FromPeriod || "",
  //     ToPeriod: row.ToPeriod || "",
  //     DueAmount: row.DueAmount || 0,
  //     SortOrder: 0,
  //     Disable: "N",
  //     Comments: row.Comments || "",
  //     Accountant: row.Hold || "N",
  //   }));

  //   console.log(dataArray, "--mapped data");

  //   const idata = {
  //     data: dataArray,
  //   };

  //   console.log(idata, "--Final Payload");

  //   // return;
  //   try {
  //     const response = await dispatch(
  //       RepaymentSchedulePost({
  //         idata: idata,
  //       })
  //     );

  //     if (response.payload.Status === "Y") {
  //       toast.success(response.payload.Msg);
  //       setIsGenerated(false);
  //       dispatch(RepaymentHDget({
  //         data: [
  //           {
  //             SalaryAdvanceID: recID,
  //             EmployeeID: EMPID,
  //           },
  //         ],
  //       }))
  //     } else {
  //       toast.error(response.payload.Msg);
  //     }
  //   } catch (error) {
  //     toast.error("Error occurred during save.");
  //   }
  // }
  const handleSaveButtonClick = async () => {
    const currentRows = isGenerated ? Repaymentget : rows;

    const dataArray = currentRows.map((row) => ({
      SalaryAdvanceID: recID || 0,
      EmployeeID: EMPID || 0,
      Type: row.Type || "",
      DueDate: row.DueDate || "",
      FromPeriod: row.FromPeriod || "",
      ToPeriod: row.ToPeriod || "",
      DueAmount: row.DueAmount || 0,
      SortOrder: 0,
      Disable: "N",
      Comments: row.Comments || "",
      Accountant: row.Accountant || "N",
    }));

    console.log(dataArray, "--mapped data");

    const idata = {
      data: dataArray,
    };

    console.log(idata, "--Final Payload");

    try {
      const response = await dispatch(
        RepaymentSchedulePost({
          idata: idata,
        })
      );

      if (response.payload.Status === "Y") {
        toast.success(response.payload.Msg);

        setIsGenerated(false);

        dispatch(
          RepaymentHDget({
            data: [
              {
                SalaryAdvanceID: recID,
                EmployeeID: EMPID,
              },
            ],
          })
        );
      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      toast.error("Error occurred during save.");
    }
  };
  const processRowUpdate = (newRow) => {
    const updatedRows = rows.map((row) =>
      row.StudentID === newRow.StudentID ? newRow : row
    );

    setRows(updatedRows);
    console.log(updatedRows, "--updatedRows");
    return newRow;
  };
  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };
  const handleRowEditStop = (params, event) => {
    // if (params.reason === GridRowEditStopReasons.rowFocusOut) {
    event.defaultMuiPrevented = true;
    // }
  };
  const handleEditClick = (StudentID) => () => {
    console.log("--calling Editclick");

    setRowModesModel({
      ...rowModesModel,
      [StudentID]: { mode: GridRowModes.Edit },
    });
  };

  const handleCancelClick = (StudentID) => () => {
    setRowModesModel({
      ...rowModesModel,
      [StudentID]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.StudentID === StudentID);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.StudentID !== StudentID));
    }
  };
  const handleSaveClick = (StudentID) => () => {
    setRowModesModel({
      ...rowModesModel,
      [StudentID]: { mode: GridRowModes.View },
    });
  };

  const [isPopupData, setisPopupdata] = React.useState(false);
  const [selectOHLookupData, setselectOHLookupData] = React.useState({
    OHlookupRecordid: "",
    OHlookupCode: "",
    OHlookupDesc: "",
  });
  if (isPopupData == false) {
    selectOHLookupData.OHlookupRecordid = data.OverHeadsID;
    selectOHLookupData.OHlookupCode = data.Code;
    selectOHLookupData.OHlookupDesc = data.Name;
  }

  const [openOHPopup, setOpenOHPopup] = useState(false);
  // const [openEMPLOYEEPopup, setOpenEMPLOYEEPopup] = useState(false);
  function handleShow(type) {
    if (type == "OH") {
      setOpenOHPopup(true);
    }

  }

  const childToParent = (childdata, type) => {
    console.log("type---" + type);
    console.log("Data---" + JSON.stringify(childdata));

    if (type == "OverHead") {
      setisPopupdata(true);
      setselectOHLookupData({
        OHlookupRecordid: childdata.RecordID,
        OHlookupCode: childdata.Code,
        OHlookupDesc: childdata.Name,
      });
      setOpenOHPopup(false);
    }

  };
  const ref = useRef(null);
  // *************** GET FILES FROM INPUT *************** //

  const getTenthDay = (date) => {
    if (!date) return "";
    const month = date.substring(0, 7); // YYYY-MM
    return `${month}-10`;
  };
  const getFileChange = async (event) => {
    setImgName(event.target.files[0]);

    console.log(event.target.files[0]);

    const formData = new FormData();
    formData.append("file", event.target.files[0]);
    formData.append("type", "attachments");

    const fileData = await dispatch(imageUpload({ formData }));
    setImgName(fileData.payload.name);
    console.log(">>>", fileData.payload);
    console.log(
      "🚀 ~ file: Editdeliverychalan.jsx:1143 ~ getFileChange ~ fileData:",
      fileData
    );
    if (fileData.payload.Status == "Y") {

      toast.success(fileData.payload.Msg);
    }
  };
  const fnLogOut = (props) => {

    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate(-1);
        }
      } else {
        return;
      }
    });
  };
  async function fileUpload(file, EMPID, action, id, purposes) {
    setimgLoading(true);
    console.log("🚀 ~ fileUpload ~ file:", file)
    const formData = new FormData();
    formData.append('file', file);
    formData.append('empId', data.EmployeeID);
    formData.append('appId', data.RecordID);
    formData.append('type', "SA");
    formData.append('source', "Self");
    formData.append('action', action);
    formData.append('id', id);
    formData.append('purpose', purposes ? purposes : "");
    console.log("🚀 ~ fileUpload ~ formData:", formData)
    const respose = await dispatch(attachmentPost({ data: formData }))

    if (respose.payload.success) {
      toast.success(respose.payload.message)
      var url = store.getState().globalurl.empGetAttachmentUrl;
      axios
        .get(url, {
          params: {
            empId: data.EmployeeID,
            appId: data.RecordID,

          }
        })
        .then((response) => {
          setFiles(response.data);
        })
        .catch((err) => {
          setError('Failed to fetch attachments.');
          console.error(err);
        })
        .finally(() => setimgLoading(false));
    } else {
      toast.success(respose.payload.message)
    }

    console.log("🚀 ~ fileUpload ~ respose:", respose)
  }
  function HomeworkTool(props) {
    const { setRows, setRowModesModel } = props;
    const handleClick = () => {
      const id = nanoid();
      const nextSLNO =
        rows.length > 0 ? Math.max(...rows.map((row) => row.SLNO || 0)) + 1 : 1;
      setRows((oldRows) => [
        ...oldRows,
        {
          RecordID: id, // Temporary ID, replaced after backend save
          SLNO: nextSLNO,
          TaskID: "",
          TaskDetailRoleID: "",
          RoleCode: "",
          RoleName: "",
          TaskDetailEffort: 0,
          TaskDetailUnit: "",
          ProjectPlanedDate: "",
          isNew: true,
        },
      ]);
      setRowModesModel((oldModel) => ({
        ...oldModel,
        [id]: { mode: GridRowModes.Edit, fieldToFocus: "TaskDetailRoleID" },
      }));
    };
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography
            variant="h5">Repayment Schedule</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }
  return (
    <React.Fragment>
      {getLoading ? <LinearProgress /> : false}
      {imgloading ? <LinearProgress /> : false}
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0", height: "60px" }}>
        {/* <Box display="flex" justifyContent="space-between" >
          <Box display="flex" borderRadius="3px" alignItems="center">
            <Breadcrumbs
              maxItems={3}
              aria-label="breadcrumb"
              separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
            >
              <Typography
                variant="h5"
                color="black"
                sx={{ cursor: "default", marginLeft: "10px", fontSize: "19px" }}
              >
                Salary Advance
              </Typography>
            </Breadcrumbs>
          </Box>
          <Box display="flex">
            <Tooltip title="Close">
              <IconButton color="error" onClick={() => fnLogOut("Close")}>
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton>

                <LogoutOutlinedIcon
                  color="error"
                  onClick={() => fnLogOut("Logout")}
                />
              </IconButton>
            </Tooltip>
          </Box>
        </Box> */}
        <Box display="flex" justifyContent="space-between" >
          <Box display="flex" borderRadius="3px" alignItems="center">
            <Breadcrumbs
              maxItems={3}
              aria-label="breadcrumb"
              separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
            >
              <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default", paddingLeft: "5px" }}
                onClick={() => {
                  setScreen(0);
                }}
              >
                {is003Subscription ? "Advance Salary" : "Salary Advance"}
              </Typography>

              {show == "1" ? (
                <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                >
                  Repayment Schedule
                </Typography>
              ) : (
                false
              )}


            </Breadcrumbs>
          </Box>
          <Box display="flex">
            {mode !== "A" ? (
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="demo-select-small">Explore</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={show}
                  label="Explore"
                  onChange={screenChange}
                >
                  <MenuItem value={0}>Salary Advance</MenuItem>
                  <MenuItem value={1}>Repayment Schedule</MenuItem>
                </Select>
              </FormControl>
            ) : (
              false
            )}

            <Tooltip title="Close">
              <IconButton color="error" onClick={() => fnLogOut("Close")}>
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton>

                <LogoutOutlinedIcon
                  color="error"
                  onClick={() => fnLogOut("Logout")}
                />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>
      {show == "0" && !getLoading ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          {/* <Box m="20px"> */}
          {mode === "IM" && (
            <Box
              display="flex"
              padding={1}
              justifyContent="flex-end"
              mt="2px"
              gridColumn="span 4"
              gap={2}
              //marginBottom={-5}
              mb={{ xs: -3, sm: -5, md: -5 }}

            >
              <IconButton
                onClick={() => setShowImage(prev => !prev)}
              >
                <ArrowDownwardIcon sx={{ color: "blue" }} />
              </IconButton>
            </Box>)}
          <Formik
            initialValues={initialValue}
            onSubmit={(values, { resetForm }) => {
              setTimeout(() => {
                salAdFNsave(values);
              }, 100);
            }}
            validationSchema={validationSchema}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
              resetForm,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(4 , minMax(0,1fr))"
                  // gap="5px"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <FormControl
                    fullWidth
                    sx={{ gridColumn: "span 2", gap: "15px" }}
                  >
                    <TextField
                      disabled={
                        mode === "M" || (
                          mode == "E" &&
                          values.Status != "AL" &&
                          values.Status != "RC"
                        )
                      }
                      name="date"
                      type="date"
                      id="date"
                      label={
                        <>
                          Date
                          <span style={{ color: "red", fontSize: "20px" }}> * </span>
                        </>
                      }
                      variant="standard"
                      focused
                      value={values.date}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      inputFormat="YYYY-MM-DD"
                      error={!!touched.date && !!errors.date}
                      helperText={touched.date && errors.date}
                      InputLabelProps={{ shrink: true }}
                    // autoFocus
                    // required
                    />
                    <TextField
                      name="applieddate"
                      type="date"
                      id="applieddate"
                      label="Applied Date"
                      variant="standard"
                      focused
                      inputFormat="YYYY-MM-DD"
                      value={values.applieddate}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.applieddate && !!errors.applieddate}
                      helperText={touched.applieddate && errors.applieddate}
                      sx={{ gridColumn: "span 2" }}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        max: new Date().toISOString().split("T")[0],
                        readOnly: true,
                      }}
                      disabled={
                        mode === "M" || (
                          mode == "E" &&
                          values.Status != "AL" &&
                          values.Status != "QR"
                        )
                      }
                    />
                    {!showImage ? <React.Fragment>
                      <TextField
                        disabled={
                          mode === "M" || (
                            mode == "E" &&
                            values.Status != "AL" &&
                            values.Status != "QR"
                          )
                        }
                        name="referenceifany"
                        type="text"
                        id="referenceifany"
                        label={
                          <>
                            Reference If Any
                            <span style={{ color: "red", fontSize: "20px" }}> * </span>
                          </>
                        }
                        variant="standard"
                        focused
                        value={values.referenceifany}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={
                          !!touched.referenceifany && !!errors.referenceifany
                        }
                        helperText={
                          touched.referenceifany && errors.referenceifany
                        }
                      // autoFocus
                      // required
                      />

                      <FormControl sx={{ gridColumn: "span 4", display: "flex" }}>
                        <CheckinAutocomplete
                          variant="outlined"
                          name="purpose"
                          label={
                            <>
                              Purpose<span style={{ color: "red", fontSize: "20px" }}> * </span>
                            </>
                          }
                          id="purpose"
                          value={values.purpose}
                          onChange={(newValue) => {
                            setFieldValue("purpose", newValue);
                          }}
                          //   value={selectedpurposeOptions}
                          //   onChange={handleSelectionpurposename}
                          // defaultValue={selectedpurposeName}

                          disabled={
                            mode === "M" || (
                              mode == "E" &&
                              values.Status != "AL" &&
                              values.Status != "QR"
                            )
                          }
                          error={!!touched.purpose && !!errors.purpose}
                          helperText={touched.purpose && errors.purpose}
                          // url={`${listViewurl}?data={"Query":{"AccessID":"2032","ScreenName":"Purpose","Filter":"FinanceCategoryType='E' AND companyID='${CompanyID}'","Any":""}}`}
                          url={`${listViewurl}?data={"Query":{"AccessID":"2032","ScreenName":"Purpose","Filter":"companyID='${CompanyID}'","Any":""}}`}
                        />
                      </FormControl>
                      {/* {touched.purpose && errors.purpose && (
                        <div style={{ color: "red", fontSize: "12px", marginTop: "-8px" }}>
                          {errors.purpose}
                        </div>
                      )} */}
                      {/* </FormControl> */}

                      <TextField
                        name="amount"
                        type="text"
                        id="amount"
                        label={
                          <>
                            Amount
                            <span style={{ color: "red", fontSize: "20px" }}> * </span>
                          </>
                        }
                        variant="standard"
                        focused
                        value={values.amount}
                        // onBlur={handleBlur}
                        // onChange={handleChange}
                        onChange={(e) => {
                          const val = e.target.value;

                          // Allow numbers with optional decimal (up to 2 digits)
                          if (/^\d*\.?\d{0,2}$/.test(val)) {
                            setFieldValue("amount", val);
                          }
                        }}
                        onBlur={(e) => {
                          handleBlur(e);
                          let val = e.target.value;

                          if (val === "" || val === ".") {
                            setFieldValue("amount", "0.00");
                            return;
                          }

                          // Ensure decimal exists
                          if (!val.includes(".")) {
                            val = `${val}.00`;
                          }

                          const num = Number(val);

                          // ✅ Force exactly 2 decimals
                          setFieldValue("amount", num.toFixed(2));
                        }}
                        error={!!touched.amount && !!errors.amount}
                        helperText={touched.amount && errors.amount}
                        disabled={
                          mode === "M" || (
                            mode == "E" &&
                            values.Status != "AL" &&
                            values.Status != "QR"
                          )
                        }
                        // autoFocus
                        InputProps={{
                          inputProps: {
                            style: { textAlign: "right" },
                            min: 0,
                            max: 24,
                          },
                        }}
                      // required
                      />

                      <TextField
                        disabled={
                          mode === "M" || (
                            mode == "E" &&
                            values.Status != "AL" &&
                            values.Status != "QR"
                          )
                        }
                        fullWidth
                        variant="outlined"
                        type="text"
                        // label="Comments"
                        label={
                          <>
                            Comments
                            <span style={{ color: "red", fontSize: "20px" }}> * </span>
                          </>
                        }
                        // required
                        multiline
                        rows={6}
                        value={values.comments}
                        id="comments"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="comments"
                        error={!!touched.comments && !!errors.comments}
                        helperText={touched.comments && errors.comments}
                        sx={{
                          gridColumn: "span 2",
                          backgroundColor: "",
                          "& .MuiFilledInput-root": {
                            backgroundColor: "",
                          },
                        }}
                        focused
                      />


                      {mode == "M" ||
                        (mode == "E" &&
                          (values.Status == "RJ" || values.Status == "QR")) ? (
                        <TextField
                          disabled={mode == "E" && values.Status != "AL"}
                          fullWidth
                          variant="outlined"
                          type="text"
                          // label="Manager Comments"
                          // required
                          label={
                            <>
                              Manager Comments
                              <span
                                style={{ color: "red", fontSize: "20px" }}
                              >
                                {" "}
                                *{" "}
                              </span>
                            </>
                          }
                          multiline
                          rows={6}
                          value={values.managerComments}
                          id="managerComments"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={
                            !!touched.managerComments &&
                            !!errors.managerComments
                          }
                          helperText={
                            touched.managerComments && errors.managerComments
                          }
                          name="managerComments"
                          sx={{
                            gridColumn: "span 2",
                          }}
                          focused
                        />
                      ) : (
                        false
                      )}
                      {mode === "M" && (
                        <TextField
                          select
                          label={
                            <>
                              Status<span style={{ color: "red", fontSize: "20px" }}> * </span>
                            </>
                          }
                          id="Status"
                          name="Status"
                          value={values.Status}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={
                            !!touched.Status &&
                            !!errors.Status
                          }
                          helperText={
                            touched.Status && errors.Status
                          }

                          focused
                          variant="standard"
                        >
                          {mode != "M" && <MenuItem value="AL">Applied</MenuItem>}
                          <MenuItem disabled={mode != "M"} value="AP">
                            Approved
                          </MenuItem>
                          <MenuItem disabled={mode != "M"} value="RJ">
                            Rejected
                          </MenuItem>
                          {mode == "M" && <MenuItem value="QR">Query</MenuItem>}
                        </TextField>
                      )}

                      {mode == "E" && values.Status == "AP" && (
                        <Alert variant="filled" sx={{ mt: 1 }} severity="success">
                          Your Salary Advance Request has been Approved.
                        </Alert>
                      )}
                      {mode == "E" && values.Status == "RJ" && (
                        <Alert variant="filled" sx={{ mt: 1 }} severity="error">
                          Your Salary Advance Request has been Rejected.
                        </Alert>
                      )}
                      {mode == "E" && values.Status == "QR" && (
                        <Alert variant="filled" sx={{ mt: 1 }} severity="warning">
                          Your Salary Advance Request has been Queried.
                        </Alert>
                      )}
                    </React.Fragment> : false}
                  </FormControl>
                </Box>
                <Box
                  display="flex"
                  padding={1}
                  justifyContent="end"
                  mt="20px"
                  gap="20px"
                >
                  {/* {mode === "E" ? (
                    <Box display="flex" alignItems="center" gap={1}>
                      <FileUploadIconButton onFileSelect={fileUpload} />
                    </Box>
                  ) : null} */}
                  {mode == "IM" && (
                    <>
                      <TextField
                        name="purposes"
                        type="text"
                        id="purposes"
                        label="Purposes"
                        variant="standard"
                        focused
                        value={values.purposes}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        autoFocus
                      />

                      <Box display="flex" alignItems="center" gap={1}>
                        <FileUploadIconButton onFileSelect={(file) => {
                          fileUpload(
                            file,
                            data.EmployeeID,
                            "upload",
                            "",
                            values.purposes
                          )
                          setFieldValue("purposes", "");
                        }}
                        />
                      </Box>
                    </>
                  )}
                  {mode != "M" &&
                    (values.Status == "AL" ||
                      values.Status == "QR" ||
                      mode == "A") && (
                      <LoadingButton
                        disabled={mode == "IM"}
                        color="secondary"
                        variant="contained"
                        type="submit"
                        loading={loading}
                      >
                        Save
                      </LoadingButton>
                    )}
                  {mode == "M" && (
                    <LoadingButton
                      disabled={mode == "IM"}
                      color="secondary"
                      variant="contained"
                      type="submit"
                      loading={loading}
                    >
                      Save
                    </LoadingButton>
                  )}
                  {/* {mode != "M" && values.Status == "AL" && (
                    <Button
                      color="error"
                      variant="contained"
                      disabled={mode == "IM"}
                      onClick={() => {
                        Swal.fire({
                          title: `Do you want Delete?`,
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Confirm",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            salAdFNsave(values, resetForm, "harddelete");
                          } else {
                            return;
                          }
                        });
                      }}
                    >
                      Delete
                    </Button>
                  )} */}
                  {mode == "M" && (
                    <Button
                      color="error"
                      variant="contained"
                      disabled={mode == "IM"}
                      onClick={() => {
                        Swal.fire({
                          title: errorMsgData.Warningmsg.Delete,
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Confirm",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            salAdFNsave(values, resetForm, "harddelete");
                            // navigate(-1);
                          } else {
                            return;
                          }
                        });
                      }}
                    >
                      Delete
                    </Button>
                  )}

                  <Button
                    type="reset"
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
          <FileListPopup
            open={open}
            onClose={() => setOpen(false)}
            appId={recID}
            empId={EMPID}
          />
          <Popup
            title="Purpose"
            openPopup={openOHPopup}
            setOpenPopup={setOpenOHPopup}
          >
            <Listviewpopup
              accessID="2032"
              screenName="OverHead"
              childToParent={childToParent}
              filterName={"FinanceCategoryType"}
              filterValue={parentID}
            />
          </Popup>
        </Paper>
      ) : (
        false
      )}
      {mode === "IM" && files.length > 0 ? (
        <Box mt={2}
        >
          <Paper elevation={3} sx={{ padding: 2 }}>
            {/* <Typography variant="h6" gutterBottom>
              Uploaded Files
            </Typography> */}
            <TableContainer component={Paper} >
              <Table size="small">
                <TableHead>
                  <TableRow sx={rowSx}>
                    <TableCell width={20}><strong>SL#</strong></TableCell>
                    <TableCell><strong>Uploaded Date</strong></TableCell>
                    <TableCell ><strong>Filename</strong></TableCell>
                    <TableCell ><strong>Purpose</strong></TableCell>
                    <TableCell ><strong>Source</strong></TableCell>
                    <TableCell><strong>View</strong></TableCell>


                  </TableRow>
                </TableHead>
                <TableBody>
                  {files.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No files uploaded yet.
                      </TableCell>
                    </TableRow>
                  ) : (
                    files.map((file, index) => (
                      <TableRow key={file.id || index} sx={rowSx}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{file.uploadedDate}</TableCell>
                        <TableCell>{file.filename}</TableCell>
                        <TableCell>{file.purpose}</TableCell>
                        <TableCell>{file.source}</TableCell>
                        <TableCell>
                          <Tooltip title="Open File">
                            <IconButton
                              color="primary"
                              component="a"
                              href={file.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              size="small"
                            >
                              <OpenInNewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="delete">
                            <IconButton
                              color="error"
                              onClick={() => fileUpload(
                                file.filename,
                                data.EmployeeID,
                                "delete",
                                file.id,
                                file.purpose
                              )}
                              size="small"
                            >
                              <DeleteForeverIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>

                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      ) : null}

      {show == "1" && !getLoading ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          {/* <Box m="10px"> */}
          <Formik
            initialValues={RepayinitialValue}
            enableReinitialize={true}
            onSubmit={(values, { resetForm }) => {
              setTimeout(() => {
                handleApplyClick(values, resetForm);
              }, 100);
            }}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              resetForm,
              setFieldValue
            }) => (
              <form
                onSubmit={handleSubmit}
                onReset={() => {
                  resetForm();
                  setRepaymentRows([]);
                  dispatch(resetTrackingData());
                }}
              >
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                  // gap="70px"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  {/* <Stack direction="row" spacing={2}> */}

                  <TextField
                    // disabled={mode == "E"}
                    name="applieddate"
                    type="date"
                    id="applieddate"
                    label="Applied Date"
                    variant="standard"
                    focused
                    inputFormat="YYYY-MM-DD"
                    value={values.applieddate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.applieddate && !!errors.applieddate}
                    helperText={touched.applieddate && errors.applieddate}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      max: new Date().toISOString().split("T")[0],
                      readOnly: true,
                    }}
                  />
                  <TextField
                    // disabled={mode == "E"}
                    // disabled={rows?.length > 0}
                    name="amount"
                    type="text"
                    id="amount"
                    label="Advance Amount"
                    variant="standard"
                    focused
                    value={values.amount}
                    // onBlur={handleBlur}
                    // onChange={handleChange}
                    onChange={(e) => {
                      const val = e.target.value;

                      // Allow numbers with optional decimal (up to 2 digits)
                      if (/^\d*\.?\d{0,2}$/.test(val)) {
                        setFieldValue("amount", val);
                      }
                    }}
                    onBlur={(e) => {
                      handleBlur(e);
                      let val = e.target.value;

                      if (val === "" || val === ".") {
                        setFieldValue("amount", "0.00");
                        return;
                      }

                      // Ensure decimal exists
                      if (!val.includes(".")) {
                        val = `${val}.00`;
                      }

                      const num = Number(val);

                      // ✅ Force exactly 2 decimals
                      setFieldValue("amount", num.toFixed(2));
                    }}
                    error={!!touched.amount && !!errors.amount}
                    helperText={touched.amount && errors.amount}
                    // autoFocus
                    InputProps={{
                      // readOnly: rows?.length > 0,
                      readOnly: true,
                      inputProps: {
                        style: { textAlign: "right" },
                        min: 0,
                        max: 24,
                      },
                    }}
                  />
                  <TextField
                    disabled={rows?.length > 0}
                    select
                    label="Type"
                    id="Type"
                    name="Type"
                    value={values.Type}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFieldValue("Type", value);
                      if (value == "F") {
                        setFieldValue("dueamount", values.amount);
                        setFieldValue("fromdate", "");
                        setFieldValue("todate", "");
                        setFieldValue("duedate", getTenthDay(values.applieddate));
                      } else {
                        setFieldValue("dueamount", "");
                      }
                    }}
                    error={
                      !!touched.Type &&
                      !!errors.Type
                    }
                    helperText={
                      touched.Type && errors.Type
                    }

                    focused
                    variant="standard"
                  >
                    <MenuItem value="F">Fully</MenuItem>
                    <MenuItem value="P">Partially</MenuItem>
                  </TextField>
                  {values.Type != "F" && (
                    <>

                      <TextField
                        disabled={rows?.length > 0}
                        name="fromdate"
                        type="month"
                        label="From Period"
                        variant="standard"
                        focused
                        value={values.fromdate || ""}
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const value = e.target.value;
                          setFieldValue("fromdate", value);
                          console.log(values.fromdate, "fromdate");
                          if (value) {
                            setFieldValue("duedate", `${value}-10`);
                          }
                        }}
                        inputProps={{
                          min: values.applieddate.substring(0, 7)
                        }}
                        sx={{
                          "& input[type=month]::-webkit-datetime-edit": {
                            color: values.fromdate ? "inherit" : "transparent"
                          },
                          "& input[type=month]:focus::-webkit-datetime-edit": {
                            color: "inherit"
                          }
                        }}
                        error={!!touched.fromdate && !!errors.fromdate}
                        helperText={touched.fromdate && errors.fromdate}
                      />

                      <TextField
                        disabled={rows?.length > 0}
                        name="todate"
                        type="month"
                        label="To Period"
                        variant="standard"
                        focused
                        value={values.todate}
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const value = e.target.value;

                          setFieldValue("todate", value);

                          if (values.fromdate && value) {
                            const from = new Date(values.fromdate);
                            const to = new Date(value);

                            const months =
                              (to.getFullYear() - from.getFullYear()) * 12 +
                              (to.getMonth() - from.getMonth()) +
                              1;
                            console.log("🚀 ~ Editsalaryadvance ~ months:", months)

                            if (months > 0) {
                              const splitAmount = values.amount / months;
                              setFieldValue("dueamount", splitAmount.toFixed(2));
                            }
                          } else {
                            setFieldValue("dueamount", values.amount);
                          }
                        }}
                        inputProps={{
                          min: values.fromdate
                        }}
                        sx={{
                          "& input[type=month]::-webkit-datetime-edit": {
                            color: values.todate ? "inherit" : "transparent"
                          },
                          "& input[type=month]:focus::-webkit-datetime-edit": {
                            color: "inherit"
                          },
                          span: 2
                        }}
                        error={!!touched.todate && !!errors.todate}
                        helperText={touched.todate && errors.todate}
                      // sx={{ span: 2 }}
                      />
                    </>
                  )}

                  <TextField
                    // disabled={mode == "E"}
                    name="duedate"
                    type="date"
                    label="Due Date"
                    variant="standard"
                    focused
                    value={values.duedate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.duedate && !!errors.duedate}
                    helperText={touched.duedate && errors.duedate}
                    inputProps={{
                      min: getTenthDay(values.fromdate),
                      max: getTenthDay(values.fromdate)
                    }}
                    sx={{ span: 2 }}
                  />
                  <TextField
                    // disabled={mode == "E"}
                    // disabled={rows?.length > 0}
                    name="dueamount"
                    type="text"
                    id="dueamount"
                    label="Due Amount"
                    variant="standard"
                    focused
                    value={values.dueamount}
                    // onBlur={handleBlur}
                    // onChange={handleChange}
                    onChange={(e) => {
                      const val = e.target.value;

                      // Allow numbers with optional decimal (up to 2 digits)
                      if (/^\d*\.?\d{0,2}$/.test(val)) {
                        setFieldValue("dueamount", val);
                      }
                    }}
                    onBlur={(e) => {
                      handleBlur(e);
                      let val = e.target.value;

                      if (val === "" || val === ".") {
                        setFieldValue("dueamount", "0.00");
                        return;
                      }

                      // Ensure decimal exists
                      if (!val.includes(".")) {
                        val = `${val}.00`;
                      }

                      const num = Number(val);

                      // ✅ Force exactly 2 decimals
                      setFieldValue("dueamount", num.toFixed(2));
                    }}
                    error={!!touched.dueamount && !!errors.dueamount}
                    helperText={touched.dueamount && errors.dueamount}
                    // autoFocus
                    InputProps={{
                      // readOnly: rows?.length > 0,
                      readOnly: true,
                      inputProps: {
                        style: { textAlign: "right" },
                        min: 0,
                        max: 24,
                      },
                    }}
                  />
                  <TextField
                    // disabled={mode == "E"}
                    fullWidth
                    variant="outlined"
                    type="text"
                    label="Comments"
                    multiline
                    rows={3}
                    value={values.comments}
                    id="comments"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    name="comments"
                    error={!!touched.comments && !!errors.comments}
                    helperText={touched.comments && errors.comments}
                    sx={{
                      // gridColumn: "span 2",
                      backgroundColor: "",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "",
                      },
                    }}
                    focused
                  />

                </Box>

                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="end"
                  padding={1}
                  width="100%"
                >
                  <Stack direction="row" spacing={2}>
                    <Button
                      variant="contained"
                      color="secondary"
                      type="button"
                      disabled={rows?.length > 0}
                      onClick={() => handleApplyClick(values)}
                    >
                      GENERATE
                    </Button>

                    {/* <Button
                      type="reset"
                      variant="contained"
                      color="error"
                      size="small"
                    >
                      Reset
                    </Button> */}
                  </Stack>
                </Stack>
                <Box m="5px">
                  <Box
                    m="5px 0 0 0"
                    //height={dataGridHeight}
                    height="50vh"
                    sx={{
                      "& .MuiDataGrid-root": {
                        border: "none",
                      },
                      "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                      },
                      "& .name-column--cell": {
                        color: colors.greenAccent[300],
                      },
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[800],
                        borderBottom: "none",
                      },
                      "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                      },
                      "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[800],
                      },
                      "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                      },
                      "& .odd-row": {
                        backgroundColor: "",
                        color: "", // Color for odd rows
                      },
                      "& .even-row": {
                        backgroundColor: "#D3D3D3",
                        color: "", // Color for even rows
                      },
                    }}
                  >
                    {/* <DataGrid
                      sx={{
                        "& .MuiDataGrid-footerContainer": {
                          height: dataGridHeaderFooterHeight,
                          minHeight: dataGridHeaderFooterHeight,
                        },
                      }}
                      rows={Repaymentget}
                      columns={column}
                      disableSelectionOnClick
                      getRowId={(row) => row.SlNo}
                      pageSize={pageSize}
                      onPageSizeChange={(newPageSize) =>
                        setPageSize(newPageSize)
                      }
                      rowHeight={dataGridRowHeight}
                      headerHeight={dataGridHeaderFooterHeight}
                      rowsPerPageOptions={[5, 10, 20]}
                      pagination
                      components={{
                        // Toolbar: empAttendanceTool,
                      }}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "odd-row"
                          : "even-row"
                      }
                      componentsProps={{
                        toolbar: {
                          showQuickFilter: true,
                          quickFilterProps: { debounceMs: 500 },
                        },
                      }}
                    /> */}
                    <DataGrid
                      sx={{
                        "& .MuiDataGrid-footerContainer": {
                          height: dataGridHeaderFooterHeight,
                          minHeight: dataGridHeaderFooterHeight,
                        },
                      }}
                      rowHeight={dataGridRowHeight}
                      headerHeight={dataGridHeaderFooterHeight}
                      rows={gridRows}
                      loading={repaymentgetLoading || RepaymentHDgetDataLoading}
                      columns={column}
                      // checkboxSelection
                      editMode="cell"
                      isCellEditable={(params) => {
                        const isInEditMode = rowModesModel[params.id]?.mode === GridRowModes.Edit;

                        // Enable editing only for the Description column when row is in edit mode
                        if (isInEditMode && params.field === "Description") {
                          return true;
                        }

                        return false;
                      }}
                      disableSelectionOnClick
                      rowModesModel={rowModesModel}
                      onRowModesModelChange={handleRowModesModelChange}
                      onRowEditStop={handleRowEditStop}
                      processRowUpdate={processRowUpdate}
                      getRowId={(row) => row.SlNo}
                      disableRowSelectionOnClick
                      experimentalFeatures={{ newEditingApi: true }}
                      onProcessRowUpdateError={(error) => {
                        console.error(
                          "Row update validation failed:",
                          error.message,
                        );

                        toast.error(error.message);
                      }}
                      components={{
                        Toolbar: HomeworkTool,
                      }}
                      componentsProps={{
                        toolbar: { setRows, setRowModesModel },
                      }}
                      rowsPerPageOptions={[5, 10, 20]}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "odd-row"
                          : "even-row"
                      }
                      pagination
                      pageSize={pageSize}
                      page={page}
                      onPageSizeChange={(newPageSize) =>
                        setPageSize(newPageSize)
                      }
                      onPageChange={(newPage) => setPage(newPage)}
                    />
                  </Box>
                  <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                    <DialogTitle sx={{ fontWeight: "bold" }}>Select an option</DialogTitle>

                    <DialogContent>

                      <RadioGroup
                        value={selectedOption}
                        onChange={(e) => setSelectedOption(e.target.value)}
                      >
                        <FormControlLabel
                          value="equal"
                          control={<Radio />}
                          label="Equally Apportionment"
                        />

                        <FormControlLabel
                          value="lastMonth"
                          control={<Radio />}
                          label="Add EMI at Last"
                        />
                      </RadioGroup>

                    </DialogContent>

                    <DialogActions>

                      <Button
                        onClick={() => {
                          setOpenDialog(false);
                          setSelectedOption("");
                        }}
                        color="error"
                      >
                        Cancel
                      </Button>
                      <Button variant="contained" onClick={handleDialogSave}>
                        Save
                      </Button>
                      {/* <Button
                        variant="contained"
                        onClick={() => {
                          console.log("Row ID:", currentRowId);
                          console.log("Selected Option:", selectedOption);

                          setOpenDialog(false);
                        }}
                      >
                        Save
                      </Button> */}

                    </DialogActions>
                  </Dialog>
                </Box>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  mt="15px"
                  gap="20px"
                  padding={1}
                >

                  <Box display="flex" flexDirection="row" padding="15px" gap={formGap}>
                    <Button
                      color="secondary"
                      variant="contained"
                      // loading={isLoading}
                      onClick={handleSaveButtonClick}
                    >
                      Save
                    </Button>

                    <Button
                      color="warning"
                      variant="contained"
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Box>
              </form>
            )}
          </Formik>

        </Paper>
      ) : (
        false
      )}
    </React.Fragment>
  );
};

export default Editsalaryadvance;
